import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Newspaper } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function AdminDigest() {
  const [lines, setLines] = useState(null);
  const [busy, setBusy] = useState(false);
  const showPreview = async () => {
    try { const { data } = await api.get("/admin/digest/preview"); setLines(data.lines); } catch (e) { toast.error(errMsg(e)); }
  };
  const sendNow = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/digest/send"); toast.success(`Résumé envoyé à ${data.emails_sent} administrateur(s) sur ${data.recipients}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border rounded-xl p-5 space-y-4 lg:col-span-2" data-testid="digest-card">
      <h3 className="font-display font-bold flex items-center gap-2"><Newspaper className="h-4 w-4 text-[#1E3A8A]" />Résumé hebdomadaire</h3>
      <p className="text-sm text-slate-600">Chaque lundi à 8h (heure de Paris), la direction (tous les administrateurs) reçoit un email avec les factures de la semaine, les validations en attente et les échéances des 14 prochains jours.</p>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={showPreview} data-testid="digest-preview-btn">Aperçu du résumé</Button>
        <Button onClick={sendNow} disabled={busy} data-testid="digest-send-btn">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Envoyer maintenant</Button>
      </div>
      {lines && (
        <div className="bg-slate-50 border rounded-md p-4 text-sm space-y-1 max-h-80 overflow-auto" data-testid="digest-preview">
          {lines.map((l, i) => <p key={i} className={/^[A-ZÉ ]{6,}/.test(l) ? "font-semibold pt-2" : "text-slate-700"}>{l}</p>)}
        </div>
      )}
    </div>
  );
}
